import {
  faBox,
  faList,
  faTag,
  faUsers,
  faRulerHorizontal,
  faRulerCombined,
  faArrowsAltV,
  faWeight,
} from '@fortawesome/free-solid-svg-icons'
import createField from '../../../utils/factory/createField'

export const productFields = [
  {
    section: 'Dados do Produto',
    fields: [
      createField({
        id: 'product.name',
        label: 'Nome',
        type: 'text',
        placeholder: 'O nome do produto é gerado automaticamente',
        disabled: true,
        icon: faBox,
      }),
      createField({
        id: 'product.type_id',
        label: 'Tipo',
        isMulti: false,
        type: 'select',
        placeholder: 'Selecione o tipo',
        icon: faList,
        isClearable: true,
      }),
      createField({
        id: 'product.brand_id',
        label: 'Marcas',
        type: 'select',
        isClearable: true,
        placeholder: 'Selecione as marcas',
        icon: faUsers,
      }),
      createField({
        id: 'product.group_id',
        label: 'Grupos',
        type: 'select',
        placeholder: 'Selecione os grupos',
        icon: faUsers,
        isClearable: true,
      }),
      createField({
        id: 'product.is_asset',
        label: 'Patrimônio',
        type: 'select',
        placeholder: 'Selecione se o produto é patrimônio',
        icon: faTag,
        fullWidth: true,
        isClearable: true,
        options: [
          { value: true, label: 'Sim' },
          { value: false, label: 'Não' },
        ],
      }),
    ],
  },
  {
    section: 'Dimensões e Peso',
    fields: [
      createField({
        id: 'product.length',
        label: 'Comprimento (cm)',
        type: 'number',
        placeholder: 'Digite o comprimento',
        icon: faRulerHorizontal,
      }),
      createField({
        id: 'product.width',
        label: 'Largura (cm)',
        type: 'number',
        placeholder: 'Digite a largura',
        icon: faRulerCombined,
      }),
      createField({
        id: 'product.height',
        label: 'Altura (cm)',
        type: 'number',
        placeholder: 'Digite a altura',
        icon: faArrowsAltV,
      }),
      createField({
        id: 'product.weight',
        label: 'Peso (kg)',
        type: 'number',
        placeholder: 'Digite o peso',
        icon: faWeight,
        isNumericFormat: true,
      }),
      createField({
        id: 'product.min_quantity',
        label: 'Estoque Mínimo',
        type: 'number',
        formatType: 'interger',
        placeholder: 'Digite o estoque mínimo',
        defaultValue: 1,
      }),
      createField({
        id: 'product.max_quantity',
        label: 'Estoque Máximo',
        type: 'number',
        formatType: 'interger',
        placeholder: 'Digite o estoque máximo',
        defaultValue: 1,
      }),
    ],
  },
]

export const editProductFields = [
  {
    section: 'Dados do Produto',
    fields: [
      createField({
        id: 'product.name',
        label: 'Nome',
        type: 'text',
        placeholder: 'O nome do produto é gerado automaticamente',
        disabled: true,
        icon: faBox,
        fullWidth: true,
      }),
      createField({
        id: 'product.type_id',
        label: 'Tipo',
        isMulti: false,
        type: 'select',
        placeholder: 'Selecione o tipo',
        icon: faList,
        disabled: true,
      }),
      createField({
        id: 'product.brand_id',
        label: 'Marcas',
        type: 'select',
        isClearable: true,
        placeholder: '-',
        icon: faUsers,
        disabled: true,
      }),
      createField({
        id: 'product.group_id',
        label: 'Grupos',
        type: 'select',
        placeholder: '-',
        icon: faUsers,
        disabled: true,
      }),
      createField({
        id: 'product.is_asset',
        label: 'Patrimônio',
        type: 'select',
        placeholder: 'Selecione se o produto é patrimônio',
        icon: faTag,
        disabled: true,
        options: [
          { value: true, label: 'Sim' },
          { value: false, label: 'Não' },
        ],
      }),
    ],
  },
  {
    section: 'Dimensões e Peso',
    fields: [
      createField({
        id: 'product.length',
        label: 'Comprimento (cm)',
        type: 'number',
        placeholder: 'Digite o comprimento',
        icon: faRulerHorizontal,
      }),
      createField({
        id: 'product.width',
        label: 'Largura (cm)',
        type: 'number',
        placeholder: 'Digite a largura',
        icon: faRulerCombined,
      }),
      createField({
        id: 'product.height',
        label: 'Altura (cm)',
        type: 'number',
        placeholder: 'Digite a altura',
        icon: faArrowsAltV,
      }),
      createField({
        id: 'product.weight',
        label: 'Peso (kg)',
        type: 'text',
        placeholder: 'Digite o peso',
        icon: faWeight,
        isNumericFormat: true,
      }),
      createField({
        id: 'product.min_quantity',
        label: 'Estoque Mínimo',
        type: 'number',
        formatType: 'interger',
        placeholder: 'Digite o estoque mínimo',
        defaultValue: 1,
      }),
      createField({
        id: 'product.max_quantity',
        label: 'Estoque Máximo',
        type: 'number',
        formatType: 'interger',
        placeholder: 'Digite o estoque máximo',
        defaultValue: 1,
      }),
    ],
  },
]

export const detailsProductFields = [
  {
    section: 'Dados do Insumo',
    fields: [
      createField({
        id: 'product.name',
        label: 'Nome',
        type: 'text',
        placeholder: 'Digite o nome do insumo',
        icon: faBox,
        disabled: true,
      }),
      createField({
        id: 'product.quantity',
        label: 'Quantidade',
        type: 'number',
        isNumericFormat: true,
        formatType: 'integer',
        placeholder: 'Digite a quantidade',
        icon: faList,
        disabled: true,
      }),
      createField({
        id: 'product.is_asset',
        label: 'Patrimônio',
        type: 'select',
        placeholder: 'Selecione se o insumo é patrimônio',
        icon: faTag,
        options: [
          { value: true, label: 'Sim' },
          { value: false, label: 'Não' },
        ],
        disabled: true,
        fullWidth: true,
      }),
    ],
  },
  {
    section: 'Características',
    fields: [
      createField({
        id: 'product.category_name',
        label: 'Categoria',
        type: 'text',
        placeholder: 'Digite o nome do insumo',
        icon: faBox,
        disabled: true,
      }),
      createField({
        id: 'product.condition_name',
        label: 'Condição',
        type: 'text',
        placeholder: 'Digite a condição',
        icon: faList,
        disabled: true,
      }),
    ],
  },
  {
    section: 'Dimensões e Peso',
    fields: [
      createField({
        id: 'product.length',
        label: 'Comprimento (cm)',
        type: 'number',
        placeholder: 'Digite o comprimento',
        icon: faRulerHorizontal,
        disabled: true,
      }),
      createField({
        id: 'product.width',
        label: 'Largura (cm)',
        type: 'number',
        placeholder: 'Digite a largura',
        icon: faRulerCombined,
        disabled: true,
      }),
      createField({
        id: 'product.height',
        label: 'Altura (cm)',
        type: 'number',
        placeholder: 'Digite a altura',
        icon: faArrowsAltV,
        disabled: true,
      }),
      createField({
        id: 'product.weight',
        label: 'Peso (kg)',
        type: 'number',
        placeholder: 'Digite o peso',
        icon: faWeight,
        disabled: true,
      }),
      createField({
        id: 'product.min_quantity',
        label: 'Estoque Mínimo',
        type: 'number',
        formatType: 'interger',
        placeholder: 'Digite o estoque mínimo',
        defaultValue: 1,
        disabled: true,
      }),
      createField({
        id: 'product.max_quantity',
        label: 'Estoque Máximo',
        type: 'number',
        formatType: 'interger',
        placeholder: 'Digite o estoque máximo',
        defaultValue: 1,
        disabled: true,
      }),
    ],
  },
]
